export const COMMERCE_PATTERN = "^[0-9]{4}([0-9]{6})([0-9]{3})([0-9]{1})$";
export const validNIT = new RegExp(COMMERCE_PATTERN);
